// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bc8f35e6","239":"0b00c40d","453":"73b66a5a","455":"0faff83d"}[chunkId] + ".chunk.js";
};